import React from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import {useSelector} from "react-redux";
import {SLIDER_CONFIG} from "../../../constants/index.jsx";
import SliderItem from "./SliderItem/SliderItem.jsx";

const Slider = () => {
    const promos = useSelector(state => state.lobby.promos);
    const {isMobile, lang} = useSelector(state => state.user);
    const options = {loop: promos?.length > 1}
    const [emblaRef] = useEmblaCarousel(options, [
        Autoplay(SLIDER_CONFIG)
    ])
    if (!promos?.length) return;
    return (
            <section className="embla">
                <div className="embla__viewport" ref={emblaRef}>
                    <div className="embla__container">
                        {promos?.map((promo, index) => {
                            const url = isMobile ? promo?.images?.mobile?.[lang] : promo?.images?.desktop?.[lang];
                            const redirectUrl = promo?.redirectUrls?.[lang];
                            return <SliderItem key={index} src={url} redirectUrl={redirectUrl}/>
                        })}
                    </div>
                </div>
            </section>
    )
}
export default Slider
